import { Icon } from '@/components/atoms'
import { FormattedI18nString } from '@/utils/FormattedI18nString'
import { useTranslation } from 'react-i18next'
import { EmailExportContent } from './EmailExportContent'

const bulletListClassName = 'text-linkPrimary material-symbols-rounded-filled'

const LIST_ITEMS = [
    {
        icon: (
            <Icon
                name="fiber_manual_record"
                className={bulletListClassName}
                size="xxsmall"
            />
        ),
        text: (
            <FormattedI18nString i18nKey="common.emailExportReportGeneration.list.firstListItem" />
        ),
    },
    {
        icon: (
            <Icon
                name="fiber_manual_record"
                className={bulletListClassName}
                size="xxsmall"
            />
        ),
        text: (
            <FormattedI18nString i18nKey="common.emailExportReportGeneration.list.secondListItem" />
        ),
    },
    {
        icon: (
            <Icon
                name="fiber_manual_record"
                className={bulletListClassName}
                size="xxsmall"
            />
        ),
        text: (
            <FormattedI18nString i18nKey="common.emailExportReportGeneration.list.thirdListItem" />
        ),
    },
]

export type EmailExportReportGenerationModalContentProps = {
    onClose: () => void
}

export const EmailExportReportGenerationModalContent: React.FC<
    EmailExportReportGenerationModalContentProps
> = ({ onClose }) => {
    const { t } = useTranslation('translations')

    return (
        <EmailExportContent
            labels={{
                saveButton: t('common.emailExportReportGeneration.closeButton'),
            }}
            list={LIST_ITEMS}
            handleOnSuccess={onClose}
            title={t('common.emailExportReportGeneration.list.title')}
        />
    )
}
